module.exports = fox._r("images/event-placeholder.gif", __webpack_public_path__ + "images/event-placeholder.gif");


//////////////////
// WEBPACK FOOTER
// ./images/event-placeholder.gif
// module id = 1021
// module chunks = 4